import React from 'react'
import Header from './Components/Header/Header'
import Sidebar from './Components/Sidebar/Sidebar'
import Status from './Components/Status/Status'

export default function Layout({ children }) {
  return (
    <div className="bg-[#e7e7e7] h-full flex flex-col w-full">
      <Header />
      <div className='flex-1 flex mt-3 overflow-auto'>
        <Sidebar />
        <div className='flex w-full flex-col gap-3 px-4'>
            {children}
        </div>
      </div>
    </div>
  )
}
